export default "__VITE_PUBLIC_ASSET__0238337d__"